import { render } from "./MenuPlotting.vue?vue&type=template&id=1eff019b"
import script from "./MenuPlotting.vue?vue&type=script&lang=js"
export * from "./MenuPlotting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__